<template>
  <div>
    <v-card class="mx-auto" flat>
      <v-card-text>
        <v-alert dense text type="info" class="mx-2 mt-3">
          <div class="black--text">
            <h4>Informasi Pengisian</h4>
            <ol class="mt-1" style="padding-inline-start: 18px">
              <li>Semua data di bawah ini <strong>wajib</strong> diisi</li>
              <li>
                Anda dapat melakukan pengisian secara bertahap sampai status laporan berubah menjadi
                <strong>dilengkapi</strong>
              </li>
            </ol>
          </div>
        </v-alert>
        <div>
          <base-form-generator :schema="schema" v-model="form" class="pt-5 px-3" />
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import BaseFormGenerator from '@/components/base/BaseFormGenerator';
export default {
  name: 'FormLaporanIht',
  components: { BaseFormGenerator },
  props: {
    masters: {
      type: Object,
      default: null,
    },
    detail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    schema() {
      return [
        {
          type: 'VTextField',
          name: 'jml_sekolah',
          label: 'Total sekolah binaan',
          placeholder: 'Tuliskan angka',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, sm: 12, md: 6 },
          mask: '######',
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VTextField',
          name: 'jml_peserta',
          label: 'Total peserta IHT',
          placeholder: 'Tuliskan angka',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, sm: 12, md: 6 },
          mask: '######',
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VDatePicker',
          name: 'tgl_mulai',
          label: 'Tanggal mulai pelaksanaan IHT',
          placeholder: 'Pilih tanggal',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VDatePicker',
          name: 'tgl_selesai',
          label: 'Tanggal selesai pelaksanaan IHT',
          placeholder: 'Pilih tanggal',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VSelect',
          name: 'k_monev_moda_psp',
          label: 'Moda Pelaksanaan IHT',
          placeholder: 'Pilih moda',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          items: this.$mapForMaster(this.masters.monev_moda_psp || {}),
          itemText: 'text',
          itemValue: 'value',
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VTextarea',
          name: 'catatan_efektif',
          label: 'Hal-hal yang sudah efektif',
          placeholder: 'Tuliskan keterangan',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12 },
          outlined: true,
          dense: true,
          singleLine: true,
          rows: 2,
          autoGrow: true,
        },
        {
          type: 'VTextarea',
          name: 'catatan_perbaikan',
          label: 'Hal-hal yang perlu ditingkatkan',
          placeholder: 'Tuliskan keterangan',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12 },
          outlined: true,
          dense: true,
          singleLine: true,
          rows: 2,
          autoGrow: true,
        },
      ];
    },
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});
      for (const sch of this.schema) {
        if (this.detail[sch.name]) {
          this.$set(this.form, sch.name, this.detail[sch.name]);
        }
      }
    },

    getValue() {
      return this.form;
    },
  },
};
</script>

<style scoped></style>
